module.exports = __webpack_public_path__ + "img/Slide8.855c5133.png";